import { defineAppConfig } from '@zto/zpage'
import type { App, AppWidgetsConfig } from '@zto/zpage'

import { xlsxUtil } from '../utils'

export default defineAppConfig<AppWidgetsConfig>((app: App) => ({
  crud: {
    export: {
      api: 'base.addExportTask',
      searchParamProp: '_parameter',
      asyncExportMethod: async ({ app, data }: PageContext, options: any) => {
        const params = {
          ...options?.exportApiParams,
          ...options?.exportApiParams?._parameter
        }
        params.pageSize = params.pageSize || 100

        delete params._parameter

        const exportData = []

        let requestData = []
        let minId = null

        let isEnd = false // 是否结束循环查询
        while (!isEnd) {
          const res = await app.request({
            api: options.api,
            params: { ...params, minId }
          })

          minId = res.minId
          requestData = res?.data || res?.list || []

          exportData.push(...requestData)

          isEnd = !minId || !requestData.length
        }

        xlsxUtil.exportData(exportData, {
          columns: data.tableAttrs?.columns || options?.columns,
          fileName: options.fileName
        })
      }
    },
    table: {
      // columnFilter: true
    }
  }
}))
